import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


/* Details query in timesheet viewer */
const GetAllSubmissionsForUserWeekQuery = gql`
  query GetAllSubmissionsForUserWeek($userId: Int!, $originDate: String!) {
    one_timesheet_for_one_user(user_id: $userId, week_of: $originDate) {
      id
      user {
        id
        fullname
      }
      time_entries {
        id
        date {
          iso8601
          display
        }
        timesheet {
          id
          document {
            id
            submission_item {
              id
            }
          }
        }       
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const [allTimeEntries] = querySelector(data, '$.one_timesheet_for_one_user.time_entries', []);
  const [user] = querySelector(data, '$.one_timesheet_for_one_user.user', []);

  return {
    ...ownProps,
    data,
    allTimeEntries,
    user,
  };
};

const queryData = graphql(GetAllSubmissionsForUserWeekQuery, {
  props: marshallData,
});

export const queryGetAllSubmissionsForUserWeekGQL = compose(
  queryData,
  queryMetaHandler,
  omitProps(['data']),
);
